<template>
	<Connections :preselectApp="service" :connectionsBySections="connectionsBySections" />
</template>

<script>
import Connections from './Connections';
import { getServiceBySlug } from '@/store/modules/apps/getters';
import { getUserCredentials } from '@/store/modules/credentials/actions';
import { getAllAccountConnections } from '@/store/modules/credentials/getters';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import { UNIDENTIFIED_SERVICE_WORKSPACE_ID } from '@/views/AppLayout/ManageAndCreate/create-and-manage.const';

export default {
	name: 'PlacementConnections',
	props: {
		serviceSlug: { type: String },
		serviceWorkspaceId: { type: String },
	},
	components: { Connections },
	computed: {
		...mapGettersShorthand({ getServiceBySlug, getAllAccountConnections }),
		allAccountConnections() {
			return Object.values(this.getAllAccountConnections);
		},
		service() {
			return this.getServiceBySlug(this.serviceSlug);
		},
		sourceList() {
			return this.serviceSlug ? this.placementConnections : this.allAccountConnections;
		},
		connectionsBySections() {
			return [
				{
					title: 'Connections',
					sourceList: this.sourceList,
					subTitle: 'Placement connections',
				},
			];
		},
		placementConnections() {
			return this.allAccountConnections.filter(
				(connection) =>
					connection.service === this.service?.id &&
					((this.serviceWorkspaceId === UNIDENTIFIED_SERVICE_WORKSPACE_ID && !connection.service_workspace?.workspace_id) ||
						connection.service_workspace?.workspace_id === this.serviceWorkspaceId)
			);
		},
	},
	methods: {
		...mapActionsShorthand({ getUserCredentials }),
		async fetchCredentials() {
			// if we got here, then we have a service
			if (!this.serviceSlug) {
				await this.getUserCredentials({ forceGet: true, used_in: true });
			} else {
				const filterBy = { service: this.service.id, service_workspace: this.serviceWorkspaceId };
				await this.getUserCredentials({ forceGet: true, filterBy, used_in: true });
			}
		},
	},
	async mounted() {
		this.fetchCredentials();
	},
	watch: {
		service: {
			handler(newV) {
				newV && this.fetchCredentials();
			},
			immediate: true,
		},
	},
};
</script>
<style scoped lang="scss"></style>
